/* Form Checkbox */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsCheckboxClick( event ) {

    /* Prevent Default */
    event.preventDefault();
    
    /* Setup */
    var checkbox = jQuery( this ).find( 'input' );
        
    /* Check Status */
    if ( !checkbox.prop( 'checked' ) && !checkbox.prop( 'disabled' ) ) {
    
        /* Check Checkbox */
        checkbox.prop( 'checked' , true );
        checkbox.parent().addClass( 'checked' );
        
    } else if ( !checkbox.prop( 'disabled' ) ) {
        
        /* Check Checkbox */
        checkbox.prop( 'checked' , false );
        checkbox.parent().removeClass( 'checked' );
    
    }
    
    /* Trigger Change Event */
    checkbox.triggerHandler( 'change' );
    
    /* If Has Validation */    
    if ( checkbox.hasClass( 'form-validated' ) ) {
        checkbox.valid();
    }

}

/* Form Checkbox - Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsCheckboxInit() {
    
    /* Loop Checkbox */
    jQuery( 'input.form-checkbox' ).each(function() {
        
        /* Get Checkbox */
        var checkbox = jQuery( this );
        
        /* Template */
        checkbox.wrap( '<label></label>' );
        
        /* Move Classes */
        checkbox.parent().attr( 'class' , checkbox.attr( 'class' ) );
        checkbox.removeClass();
        
        /* If Label */
        if ( checkbox.data( 'label' ) !== undefined && checkbox.data( 'label' ) ) {
            checkbox.parent().append( checkbox.data( 'label' ) );    
        }
        
        /* Add Icon */
        checkbox.parent().append( '<i></i>' );
        
        /* Checked */
        if ( checkbox.prop( 'checked' ) ) {
        
            /* Add Class */
            checkbox.parent().addClass( 'checked' );
        
        }
        
        /* Add Click Event */
        checkbox.parent().on( 'click' , ipcrimeFormsCheckboxClick );
        
        /* Disabled */
        ipcrimeFormsStyleDisabled( checkbox );

    });

}